<template>
  <v-container v-if="userProfile">
    <v-container style="background: white">
      <v-row>
        <v-col cols="6" v-if="userProfile">
          <v-card elevation="0">
            <h1>
              Сайн байна уу?
              <span>
                <span class="font-weight-bold"
                  >{{ userProfile.firstName }} </span
                ><span v-if="userProfile.lastName"> </span
              ></span>
            </h1>
            <p>
              Тэнxим:
              <span
                class="font-weight-bold text-danger"
                v-if="userProfile && userProfile.departmentName"
                >{{ userProfile.departmentName }}</span
              >
            </p>
            <p v-if="userProfile.role == 'student'">
              Оюутны код:
              <span class="font-weight-bold">{{
                userProfile.studentCode
              }}</span>
            </p>
          </v-card>
        </v-col>
        <v-col v-if="userProfile.role == 'student' && classInfo" cols="6">
          <v-card
            class="py-2"
            width="100%"
            height="100%"
            elevation="0"
            color="teal lighten-5"
          >
            <v-row>
              <v-col cols="6">
                <v-card-text>
                  Мэргэжил
                  <p class="font-weight-bold">
                    {{ classInfo.name }},
                    <span>
                      {{ classInfo.shortName }}-
                      {{ classInfo.classNumber }}</span
                    >
                  </p>
                  <p>{{ classInfo.xprofessiondegreeName }}</p>
                  Xөтөлбөр
                  <p class="font-weight-bold">
                    {{ classInfo.xcurriculumName }}
                  </p>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                Голч
                <h1>{{ userProfile.currentGPA }}</h1>
                Оноо оруулсан огноо:
                <p class="font-weight-bold">
                  {{ userProfile.currentGPADate | formatDate }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <material-card
      v-if="userProfile && userProfile.role == 'student'"
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      class="mt-10"
    >
      <v-container>
        <v-row class="px-16 py-4">
          <v-col cols="8">
            <v-row>
              <div cols=""
                v-for="(xx, xxIndex) in [
                  { name: 'Лекц', lessonType: 'lectures' },
                  { name: 'Семинар', lessonType: 'seminars' },
                  { name: 'Дадлага', lessonType: 'homeworks' },
                  { name: 'Лаборатори', lessonType: 'labworks' },
                ]"
                :key="'colorDescription' + xxIndex"
              >
                <span style="height: 10px; width: 10px" :style="_getColor(xx)"
                  >____</span
                >
                <span class="mr-4"> {{ xx.name }}</span>
              </div>
            </v-row>
          </v-col>
          <v-col cols="4">
            <h2>{{userProfile.school.currentSemesterYears}}, {{ userProfile.school.currentSemesterName }}</h2>
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-row class="px-16">
        <v-col><v-btn x-small elevation="0" :style="_getColor({lessonType:'lectures'})">L</v-btn></v-col>
        <v-col><v-btn x-small elevation="0" :style="_getColor({lessonType:'lectures'})">L</v-btn></v-col>
        <v-col><v-btn x-small elevation="0" :style="_getColor({lessonType:'lectures'})">L</v-btn></v-col>
      </v-row> -->

      <table class="px-16 pb-10 pt-4" style="border-spacing: 0px">
        <tr>
          <th
            class="xeelj-table-hcell"
            style="width: 10px !important; text-align: center"
          >
            No.
          </th>
          <th class="xeelj-table-hcell">Xичээлийн цаг</th>
          <th
            class="xeelj-table-cell"
            v-for="x in weekDays"
            :key="'weekday-' + x.wNum"
          >
            {{ x.wName }}
          </th>
        </tr>
        <tr v-for="(eelj, eeljIndex) in xeelj" :key="eelj.id">
          <td
            class="xeelj-table-hcell font-weight-bold text-center"
            style="width: 10px !important; background: #ececec"
          >
            {{ eeljIndex + 1 }}
          </td>
          <td class="xeelj-table-hcell" style="width: 240px">
            {{ eelj.name }}
          </td>
          <td
            class="xeelj-table-cell"
            style="width: 200px"
            v-for="cell in weekDays"
            :key="'cell-' + cell.wNum"
          >
            <span v-if="isTimeTableAssigned(eelj, cell) != null">
              <v-chip
                small
                v-if="perGroup"
                :style="_getColor()"
                :title="isTimeTableAssigned(eelj, cell).lessonType"
                >{{ isTimeTableAssigned(eelj, cell).classGroupsName }}
                <span
                  style="color: #000"
                  v-if="isTimeTableAssigned(eelj, cell).roomCode"
                  >/{{ isTimeTableAssigned(eelj, cell).roomCode }}/</span
                >
              </v-chip>

              <v-card
                small
                v-else
                :style="_getColor(isTimeTableAssigned(eelj, cell))"
                :title="isTimeTableAssigned(eelj, cell).lessonType"
                style="cursor: pointer"
                width="200"
              >
                <v-card-text class="pt-1 pb-0 text-start">
                  <span class="font-weight-bold"
                    >{{ isTimeTableAssigned(eelj, cell).name }} ({{
                      isTimeTableAssigned(eelj, cell).roomCode
                    }})</span
                  >
                </v-card-text>
                <v-card-text class="py-1 text-start">
                  {{ _getTeacherName(isTimeTableAssigned(eelj, cell)) }}
                </v-card-text>
              </v-card>
            </span>
          </td>
        </tr>
      </table>
    </material-card>
  </v-container>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
import LessonTable from "@/views/lessons/LessonTable.vue";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      xeelj: null,
      perGroup: false,
      semesters: null,
      test: "/schools/YJHjHWUGDok8teDhDIKX/students/am14d001/scores",
      studentScores: null,
      classInfo: null,
      weekDays: [
        { wName: "Да", wNum: 1 },
        { wName: "Мя", wNum: 2 },
        { wName: "Лx", wNum: 3 },
        { wName: "Пү", wNum: 4 },
        { wName: "Ба", wNum: 5 },
      ],
      timetables: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  async created() {
    if (
      this.userProfile["xClassGroupProgram-2022-2023-1"] &&
      this.userProfile["xClassGroupProgram-2022-2023-1"].ref &&
      this.userProfile.school &&
      this.userProfile.school.currentSemesterRef
    ) {
      var query = fb.db
        .collection(fb.yyschool + "/lessons")
        .where("semesterRef", "==", this.userProfile.school.currentSemesterRef)
        .where("confirmed", "==", true)
        .where(
          "classGroupProgramRefs",
          "array-contains",
          this.userProfile["xClassGroupProgram-2022-2023-1"].ref
        )
        .orderBy("createdAt", "desc");

      query.onSnapshot((querySnapshot) => {
        var counter = 0;
        this.timetables = [];
        querySnapshot.forEach((doc) => {
          counter++;
          let lesson = doc.data();
          lesson.ref = doc.ref;
          lesson.id = doc.id;
          lesson.index = counter;
          console.log(lesson.ref.path)
          lesson.ref.collection("calendars-2022").onSnapshot((docs) => {
            docs.forEach((doc) => {
              let tt = doc.data();
              tt.ref = doc.ref;
              tt.id = doc.id;
              tt.createdDate = lesson.createdAt;
              this.timetables.push(tt);
            });
          });
        });
      });
    }
    this.userProfile.ref.parent.parent
      .collection("xeelj")
      .orderBy("startTime", "asc")
      .get()
      .then((docs) => {
        this.xeelj = [];
        docs.forEach((doc) => {
          let eelj = doc.data();
          eelj.ref = doc.ref;
          eelj.id = doc.id;
          this.xeelj.push(eelj);
        });
      });

    this.userProfile.ref.get().then(async (student) => {
      var yy = await student.data();
      if (
        yy &&
        yy["xClassGroupProgramRef-2022-2023-1"] &&
        yy["xClassGroupProgramRef-2022-2023-1"]
      ) {
        yy["xClassGroupProgramRef-2022-2023-1"].get().then((doc) => {
          let classInfo = doc.data();
          classInfo.ref = doc.ref;
          classInfo.id = doc.id;
          this.classInfo = classInfo;
        });
      } else {
        if (
          yy &&
          yy["xClassGroupProgram-2022-2023-1"] &&
          yy["xClassGroupProgram-2022-2023-1"].ref
        ) {
          yy["xClassGroupProgram-2022-2023-1"].ref.get().then((doc) => {
            let classInfo = doc.data();
            classInfo.ref = doc.ref;
            classInfo.id = doc.id;
            this.classInfo = classInfo;
          });
        }
      }
    });
  },
  methods: {
    _getTeacherName(tt) {
      if (tt.teacherLastName && tt.teacherLastName.length > 0) {
        return tt.teacherLastName[0] + ". " + tt.teacherFirstName;
      } else return tt.teacherFirstName;
    },
    _getColor(content) {
      var color = "background-color:#3F51B5; color:#fff";
      if (content.lessonType == "lectures") {
        color = "background-color:#02BCD4; color:#fff";
      } else if (content.lessonType == "seminars") {
        color = "background-color:#FF9801; color:#fff";
      } else if (content.lessonType == "labworks") {
        color = "background-color:#673AB7; color:#fff";
      } else if (content.lessonType == "homeworks") {
        color = "background-color:#3F51B5; color:#fff";
      }

      return color;
    },
    isTimeTableAssigned(eelj, cell) {
      if (this.timetables) {
        for (var tt of this.timetables) {
          if (tt.eelj.id == eelj.id && tt.weekday == cell.wNum) {
            return tt;
          }
        }
      }
      return null;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style>
.xeelj-table-hcell {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.xeelj-table-cell {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
  cursor: pointer;
}
</style>